import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let ColorComp;

class Color extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: ColorComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/base-components/color-comp" */
      "../../../components/javascript/base-components/color-comp").then(function(res) {
        ColorComp = res.ColorComp;
      })
    );

    
;
  }
}

export { Color };
